// ** Reducers Imports
import shortlink from './store/shortlink/reducer';

const rootReducer = {
    shortlink
};

export default rootReducer;
